import { useQuery } from 'data-fetching-client';
import { GET_ELIGIBLE_BREEZE_SKUS } from 'pricing-pages-api/eligible-breeze-skus/queries';
import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from '../selectors/AuthSelectors';
import { isUngatedForBreezeIntelligenceSelector } from '../selectors/GatingSelectors';

/**
 * Hook to fetch eligible Breeze products either in-app or public
 *
 * @param {ApiName[]} apiNames - Only needed when we want to determine eligible breeze products from PUBLIC endpoint based on selected api names.
 * @param {boolean} skip - Pass through skip condition to the query.
 */
export const useEligibleBreezeProducts = ({
  apiNames,
  skip
}) => {
  var _COUNTRY_CODE_FROM_LO;
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isUngatedForBreezeIntelligence = useAppSelector(isUngatedForBreezeIntelligenceSelector);
  const countryCode = ((_COUNTRY_CODE_FROM_LO = window.COUNTRY_CODE_FROM_LOCALE) === null || _COUNTRY_CODE_FROM_LO === void 0 ? void 0 : _COUNTRY_CODE_FROM_LO.toUpperCase()) || 'US';
  const {
    data,
    error,
    loading
  } = useQuery(GET_ELIGIBLE_BREEZE_SKUS, {
    variables: {
      noAuth: !isAppAuth,
      apiNames,
      countryCode
    },
    skip: skip || !isUngatedForBreezeIntelligence
  });
  return {
    eligibleBreezeApiNames: data === null || data === void 0 ? void 0 : data.eligibleBreezeSkus,
    error,
    loading
  };
};